import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { Button } from 'newcomponents/UI/Button';

type TLoadMoreButtonProps = {
  onClick: () => void;
  loadMoreBtnLoading: boolean;
};

export const LoadMoreButton = memo(
  ({ onClick, loadMoreBtnLoading }: TLoadMoreButtonProps) => {
    const { t } = useTranslation();

    return (
      <div
        className={cc([
          'loadMoreButton',
          {
            'loadMoreButton--mobile': isMobile()
          }
        ])}
      >
        <Button
          fullwidth={isMobile()}
          loading={loadMoreBtnLoading}
          onClick={onClick}
          className={cc([
            'loadMoreButton__btn',
            {
              'loadMoreButton__btn--mobile': isMobile()
            }
          ])}
          type={isMobile() ? 'secondary' : 'primary'}
        >
          {t('sportsbook.loadMore')}
        </Button>
      </div>
    );
  }
);
